import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const categorySchema = z.object({
  id: z.number(),
  leaf_category_name: z.string(),
  market_place: z.string(),
});

const bySchema = z
  .object({
    first_name: z.string(),
    last_name: z.string(),
    is_staff: z.boolean().optional(),
  })
  .nullable();

const stageSchema = z.array(
  z.object({
    id: z.number(),
    name: z.string(),
    category: categorySchema,
    keywords: z.array(z.string()),
    created_by: bySchema,
    updated_by: bySchema,
    created_on: z.string(),
    updated_on: z.string(),
    deleted_on: z.string().nullable(),
    deleted_by: bySchema,
  }),
);

const querySchema = z.object({
  id: z.number(),
  query: z.string(),
  fetched_query: z.string(),
  stage: z.object({
    id: z.number(),
    name: z.string(),
  }),
  category: categorySchema,
  score: z.number(),
  metadata: z.any(),
  created_by: bySchema,
  updated_by: bySchema,
  created_on: z.string(),
  updated_on: z.string(),
  deleted_on: z.string().nullable(),
  deleted_by: bySchema,
  org: z.number(),
});
// export type query = z.infer<typeof querySchema>;
// export type stage = z.infer<typeof stageSchema>;

export const queryApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getqueriescategory",
    method: "get",
    path: "/queries",
    status: 200,
    parameters: [
      {
        name: "category_id",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "start_date",
        type: "Query",
        schema: z.string(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string(),
      },
    ],
    response: z.array(querySchema),
  }).build(),
);

export const stageApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getquerystage",
    method: "get",
    path: "/stages",
    status: 200,
    response: z.array(stageSchema),
  }).build(),
);

// stage-stats

const queryStageSchema = z.object({
  category: z.object({
    id: z.number(),
    name: z.string(),
    market_place: z.string(),
  }),
  stages: z.array(
    z.object({
      stage: z.number().nullable(),
      stage_name: z.string().nullable(),
      queries: z.array(z.string()),
    }),
  ),
});

export const queryStages = prefixApi(
  "/api",
  apiBuilder({
    alias: "getquerystages",
    method: "get",
    path: "/category-stage-review/:category_id",
    parameters: [
      {
        name: "category_id",
        type: "Path",
        schema: z.string(),
        description: "Category ID",
      },
      {
        name: "start",
        type: "Query",
        schema: z.string().nullable(),
        description: "start date in YYYY-MM-DD format",
      },
      {
        name: "end",
        type: "Query",
        schema: z.string().nullable(),
        description: "end date in YYYY-MM-DD format",
      },
      {
        name: "group",
        type: "Query",
        schema: z.string().nullable(),
        description: "group",
      },
    ],
    status: 200,
    response: queryStageSchema,
  }).build(),
);
